import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function ReceiptInvoice(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(
    SvgIcon,
    {
      ...rest,
      "data-tidal": "TidalIllustration",
      "data-tidal-illustration": "ReceiptInvoice",
      sx,
      viewBox,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M29 17h6.667A1.334 1.334 0 0 0 37 15.667V8.333A3.333 3.333 0 0 0 33.667 5H29v12Z",
            fill: theme.vars.palette.primary.light
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M29.081 43a1.405 1.405 0 0 0 1.405-1.407V8.519c0-.934.37-1.829 1.03-2.488A3.511 3.511 0 0 1 34 5H15.027a7.022 7.022 0 0 0-4.969 2.061A7.042 7.042 0 0 0 8 12.037V43h21.081Z",
            fill: theme.vars.palette.secondary.main
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M29 43a1.37 1.37 0 0 1-.998-.44 1.55 1.55 0 0 1-.414-1.06v-3c0-.398-.149-.78-.413-1.06a1.37 1.37 0 0 0-.998-.44H6.412a1.37 1.37 0 0 0-.998.44A1.549 1.549 0 0 0 5 38.5V40c0 .796.297 1.559.827 2.121.53.563 1.248.879 1.997.879H29Zm-2.727-27.6H11.727a.742.742 0 0 1-.514-.205A.687.687 0 0 1 11 14.7c0-.186.077-.364.213-.495a.742.742 0 0 1 .514-.205h14.546c.193 0 .378.074.514.205s.213.31.213.495a.687.687 0 0 1-.213.495.742.742 0 0 1-.514.205Zm0 4.2H11.727a.742.742 0 0 1-.514-.205A.687.687 0 0 1 11 18.9c0-.186.077-.364.213-.495a.742.742 0 0 1 .514-.205h14.546c.193 0 .378.074.514.205s.213.31.213.495a.687.687 0 0 1-.213.495.742.742 0 0 1-.514.205Zm-5.819 4.2h-8.727a.742.742 0 0 1-.514-.205A.687.687 0 0 1 11 23.1c0-.186.077-.364.213-.495a.742.742 0 0 1 .514-.205h8.727c.193 0 .378.074.515.205a.69.69 0 0 1 .213.495.687.687 0 0 1-.213.495.742.742 0 0 1-.515.205ZM17.546 28h-5.818a.742.742 0 0 1-.514-.205A.687.687 0 0 1 11 27.3c0-.186.077-.364.213-.495a.742.742 0 0 1 .514-.205h5.819c.192 0 .377.074.514.205a.69.69 0 0 1 .213.495.687.687 0 0 1-.213.495.742.742 0 0 1-.514.205Z",
            fill: theme.vars.palette.primary.light
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M31.5 43C37.851 43 43 37.851 43 31.5S37.851 20 31.5 20 20 25.149 20 31.5 25.149 43 31.5 43Z",
            fill: theme.vars.palette.primary.dark
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M32.2 30.778v-2.89c.371 0 .727.153.99.424.263.27.41.638.41 1.021 0 .192.074.376.205.511a.69.69 0 0 0 .495.212.69.69 0 0 0 .495-.212.734.734 0 0 0 .205-.51c0-.767-.295-1.502-.82-2.043a2.757 2.757 0 0 0-1.98-.847v-.722a.734.734 0 0 0-.205-.51A.69.69 0 0 0 31.5 25a.69.69 0 0 0-.495.212.734.734 0 0 0-.205.51v.722c-.743 0-1.455.305-1.98.847a2.936 2.936 0 0 0-.82 2.042c0 .767.295 1.501.82 2.043a2.757 2.757 0 0 0 1.98.846v2.89a1.38 1.38 0 0 1-.99-.424 1.468 1.468 0 0 1-.41-1.021.734.734 0 0 0-.205-.511.69.69 0 0 0-.495-.212.69.69 0 0 0-.495.212.734.734 0 0 0-.205.51c0 .767.295 1.502.82 2.043a2.757 2.757 0 0 0 1.98.847v.722c0 .191.074.375.205.51A.69.69 0 0 0 31.5 38a.69.69 0 0 0 .495-.212.734.734 0 0 0 .205-.51v-.722c.743 0 1.455-.305 1.98-.847.525-.541.82-1.276.82-2.042 0-.767-.295-1.501-.82-2.043a2.757 2.757 0 0 0-1.98-.846Zm-2.8-1.445c0-.383.148-.75.41-1.021.263-.27.619-.423.99-.423v2.889a1.38 1.38 0 0 1-.99-.423 1.468 1.468 0 0 1-.41-1.022Zm2.8 5.778v-2.889c.371 0 .727.152.99.423s.41.639.41 1.022-.148.75-.41 1.021c-.263.27-.619.423-.99.423Z",
            fill: theme.vars.palette.secondary.main
          }
        )
      ]
    }
  );
}
ReceiptInvoice.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "ReceiptInvoice"
};
validateTidalLicense();
export {
  ReceiptInvoice
};
//# sourceMappingURL=ReceiptInvoice.js.map
